import type { TranslationFnc } from '~/_shared/utils/hooks';
import {
  DEMOGRAPHIC_REGIONS_FOR_PREMIUM_DATA,
  type DemographicRegion, DemographicRegions,
} from './demographics.types';

export const getDemographicsRegionTranslation = (
  region: DemographicRegion,
  t: TranslationFnc,
) => {
  switch (region) {
    case DemographicRegions.CA:
    case DemographicRegions.US:
      return t(`demographicsRegion.${region}`);
    default:
      return '-';
  }
};

export const getDemographicsRegionsOptions = ({
  t,
  onlyPremiumDataRegions,
}: {
  t: TranslationFnc;
  onlyPremiumDataRegions?: boolean;
}) => Object.values(DemographicRegions).map((region) => ({
  name: getDemographicsRegionTranslation(region, t),
  value: region,
})).filter(option => !onlyPremiumDataRegions || DEMOGRAPHIC_REGIONS_FOR_PREMIUM_DATA.includes(option.value));
